export default __webpack_public_path__ + "static/media/02.abb492c6.mp4";